<template>
  <div>
    <!-- 配送单并单出货 -->
    <el-dialog :title="$t('message.shippingOrdersAndShippingOrders')" :close-on-click-modal="false"
      :visible.sync="$parent.andSingleDialogVisible" width="520px" center>
      <div class="content">
        <h6>{{ $t("message.associateTheSubDeliverySingleNumber") }} ：
          <!--可关联配送单  -->
          <el-button type="primary" @click="relatedDeliveryOrder">{{
            $t("message.relatedDeliveryOrder")
          }}</el-button>
        </h6>
        <div class="row" v-for="(item, index) in itemData.sub_porder" :key="index">
          <el-input v-model="item.porder_sn"> </el-input>
          <i class="el-icon-remove-outline" @click="delItem(index)"></i>
        </div>
        <el-button size="mini" type="success" @click="add">{{
          $t("message.add")
        }}</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="$parent.andSingleDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 可关联配送单 -->
    <el-dialog :title="$t('message.relatedDeliveryOrder')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="600px" center>
      <div class="content">
        <div class="table">
          <ol>
            <li>选择</li>
            <li>状态</li>
            <li class="flex2">配送单号</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li><el-checkbox v-model="item.checked"></el-checkbox></li>
            <li>{{ item.status_cn }}</li>
            <li class="flex2">{{ item.porder_sn }}</li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 并单 -->
        <el-button type="primary" @click="andSingle">{{
          $t("message.andSingle")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    itemData: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
      userRoleStatus: localStorage.getItem("japanUserRoleStatus"),
      tableData: [],
    };
  },
  created() {
    console.log(this.itemData);
  },
  methods: {
    // 新增
    add() {
      if (this.itemData.sub_porder == false) {
        this.itemData.sub_porder = [
          {
            porder_sn: "",
          },
        ];
      } else {
        this.itemData.sub_porder.push({
          porder_sn: "",
        });
      }
    },
    // 删除
    delItem(i) {
      this.itemData.sub_porder.splice(i, 1);
    },
    // 保存
    save() {
      let datas = {
        porder_sn: this.itemData.porder_sn,
        sub_porder_sn: [],
      };
      this.itemData.sub_porder.forEach((item) => {

        datas.sub_porder_sn.push(item.porder_sn);
      });

      this.$api.porderApi.updateSubPorder(datas).then((res) => {
        this.$alert(
          `并单发货的单子，发票默认获取主单的进口商信息，请注意主单进口商信息是否正确`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            center: true,
            callback: (actions) => {
              if (res.msg != '操作成功') {
                this.$alert(res.msg,
                  "提示",
                  {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "确定",
                    center: true,
                    callback: (actions) => {
                    },
                  }
                );
              }
            },
          }
        );
        this.$parent.andSingleDialogVisible = false;
        this.$parent.generalList();
      });
    },
    // 并单
    andSingle() {
      this.tableData.forEach((item) => {
        if (item.checked) {
          this.itemData.sub_porder.push({
            porder_sn: item.porder_sn,
          });
        }
      });
      // 根据porder_sn去重
      // 数组去重
      var hash = {};
      this.itemData.sub_porder = this.itemData.sub_porder.reduce(function (item, next) {
        hash[next.porder_sn]
          ? ""
          : (hash[next.porder_sn] = true && item.push(next));

        return item;
      }, []);
      this.dialogVisible = false;
    },
    // 关联配送单保存
    relatedDeliveryOrder() {
      this.$api.porderApi.mergeableCandidateList({
        porder_sn: this.itemData.porder_sn,
      }).then((res) => {
        res.data.forEach((item) => {
          item.checked = item.is_linked == 1 ? true : false;
        })

        this.tableData = res.data;

      });
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 0 30px;

  h6 {
    font-size: 18px;
    margin-bottom: 12px;
  }

  .row {
    display: flex;
    margin-bottom: 12px;

    i {
      margin-left: 20px;
      font-size: 25px;
      line-height: 40px;
      cursor: pointer;
    }
  }

  .table {
    max-height: 600px;
    overflow-y: auto;

    .flex2 {
      flex: 2;
    }
  }
}
</style>